const config = {
  API_BASE_URL: '/test-api'
}

export default config
